"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PopoverMask = exports.PopoverClose = exports.PopoverLinkText = exports.PopoverItem = exports.PopoverTitleCount = exports.PopoverTitle = exports.PopoverTitleContainer = exports.PopoverContainer = exports.PopoverContent = exports.StyledPopover = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _popover = _interopRequireDefault(require("antd/lib/popover"));

require("antd/lib/popover/style/index.css");

var _CloseButton = _interopRequireDefault(require("../../CloseButton"));

var _StyledLink = _interopRequireDefault(require("../../StyledLink"));

var _StyledLayout = require("../../StyledLayout");

var _OldModal = require("../../OldModal");

var _StyledTypography = require("../../StyledTypography");

require("./StyledPopover.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledPopover = (0, _styledComponents["default"])(_popover["default"]).withConfig({
  displayName: "StyledPopover",
  componentId: "sc-1279jqe-0"
})([""]);
exports.StyledPopover = StyledPopover;

var PopoverContent = _styledComponents["default"].div.withConfig({
  displayName: "StyledPopover__PopoverContent",
  componentId: "sc-1279jqe-1"
})(["padding:", ";padding-top:0;overflow-y:auto;height:100%;", ";"], function (props) {
  return props.theme.spacingSm;
}, _StyledLayout.spacing);

exports.PopoverContent = PopoverContent;

var PopoverContainer = _styledComponents["default"].div.withConfig({
  displayName: "StyledPopover__PopoverContainer",
  componentId: "sc-1279jqe-2"
})(["display:flex;flex-direction:column;position:relative;width:", ";height:", ";max-height:100%;", " ", " @media (max-width:", "){width:calc(100vw - ", ");}@media (max-width:", "){.ant-popover-arrow{display:none;}}"], function (props) {
  return props.width || '408px';
}, function (props) {
  return props.height || props.dropdownMenu && 'auto' || '604px';
}, function (props) {
  return props.dropdownMenu && (0, _styledComponents.css)(["width:240px;", "{padding-top:", ";padding-bottom:", ";}"], PopoverContent, props.theme.spacingXs, props.theme.spacingXs);
}, function (props) {
  return !props.dropdownMenu && !props.tooltip && (0, _styledComponents.css)(["@media (max-width:", "px){height:490px;}@media (max-width:", "px){height:410px;}"], props.theme.responsiveMedium, props.theme.responsiveSmall);
}, function (props) {
  return props.width || '440px';
}, function (props) {
  return props.theme.spacingLg;
}, function (props) {
  return props.width || '480px';
});

exports.PopoverContainer = PopoverContainer;

var PopoverTitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "StyledPopover__PopoverTitleContainer",
  componentId: "sc-1279jqe-3"
})(["height:72px;display:flex;align-items:center;justify-content:center;", ";"], _StyledLayout.spacing);

exports.PopoverTitleContainer = PopoverTitleContainer;
var PopoverTitle = _OldModal.ModalTitle;
exports.PopoverTitle = PopoverTitle;
var PopoverTitleCount = _OldModal.ModalTitleCount;
exports.PopoverTitleCount = PopoverTitleCount;

var PopoverItem = _styledComponents["default"].div.withConfig({
  displayName: "StyledPopover__PopoverItem",
  componentId: "sc-1279jqe-4"
})(["width:", ";padding:", " 0;", ";", ""], function (props) {
  return props.fullWidth && '100%';
}, function (props) {
  return props.theme.spacingXs;
}, _StyledLayout.spacing, function (props) {
  return props.hoverBlue && (0, _styledComponents.css)(["margin-left:-", ";margin-right:-", ";padding-left:", ";padding-right:", ";&:hover,&:focus{background-color:", ";outline:none;", ",", "{color:", ";}", "{svg .inline_svg_icon__fill,svg path{fill:", ";}}}"], props.theme.spacingSm, props.theme.spacingSm, props.theme.spacingSm, props.theme.spacingSm, props.theme.bgColorMenuHover, _StyledTypography.Paragraph, _StyledLink["default"], props.theme.fontColorWhite, _StyledLink["default"], props.theme.iconColorWhite);
});

exports.PopoverItem = PopoverItem;
var PopoverLinkText = (0, _styledComponents["default"])(_StyledTypography.Paragraph).withConfig({
  displayName: "StyledPopover__PopoverLinkText",
  componentId: "sc-1279jqe-5"
})(["padding-left:", ";margin-left:", ";", ""], function (props) {
  return props.textOnlyMenu && '0' || props.theme.spacingLg;
}, function (props) {
  return props.theme.spacingXs;
}, function (props) {
  return (props.withIcon || props.iconSrc) && (0, _styledComponents.css)(["padding-left:", ";margin-left:0;"], props.theme.spacingSm);
});
exports.PopoverLinkText = PopoverLinkText;

var PopoverClose = _styledComponents["default"].div.withConfig({
  displayName: "StyledPopover__PopoverClose",
  componentId: "sc-1279jqe-6"
})(["display:flex;align-items:center;justify-content:center;position:absolute;cursor:pointer;top:0;left:0;", ""], _CloseButton["default"]);

exports.PopoverClose = PopoverClose;

var PopoverMask = _styledComponents["default"].div.withConfig({
  displayName: "StyledPopover__PopoverMask",
  componentId: "sc-1279jqe-7"
})(["display:", ";position:fixed;top:0;left:0;width:100%;height:100%;@media (max-width:480px){background-color:", ";}"], function (props) {
  return !props.visible && 'none';
}, function (props) {
  return props.theme.bgColorDarkMask;
});

exports.PopoverMask = PopoverMask;